<div class="page-container" [ngClass]="globalClasses">
	<app-header></app-header>
	<div class="page-content">
		<router-outlet></router-outlet>
	</div>
	<app-footer></app-footer>
</div>
